exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tbody:nth-child(even) tr {\n  background: #f5f7f9; }\n\ntable tbody:nth-child(odd) tr {\n  background: #ffffff; }\n\n.hide tr:nth-child(even) {\n  background: #ffffff !important; }\n\n.hide tr:nth-child(odd) {\n  background: #f5f7f9 !important; }\n\n[data-toggle=\"toggle\"] {\n  display: none; }\n\n.table-style tbody tr:hover {\n  background-color: #fbb034 !important;\n  cursor: pointer; }\n\n.close {\n  font-size: 2rem !important; }\n\n#majorShare {\n  margin-top: 0.75rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/major-shareholder/major-shareholder.component.scss
// module id = ../../../../../src/app/securities-level/major-shareholder/major-shareholder.component.scss
// module chunks = main